/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateCopyRequest} from '@cash-web/protos/squareup/consentsys/service.pb'
import {CreateCopyResponse} from '@cash-web/protos/squareup/consentsys/service.pb'


export const createCopy = (request: CreateCopyRequest, options?: CashRequestOptions) => post<CreateCopyRequest, CreateCopyResponse>("/2.0/cash/create-copy", request, {...options, rejectOnError: true })